
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "CSubscriptionUnitScheduleStatus"
})
export default class CSubscriptionUnitScheduleStatus extends Vue {
  @Prop({ required: true }) current_skill_level!: number;
}
